import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface StateProps {
  path?: string;
  icon?: ReactNode;
  label: string;
  className?: string;
  onClick?: Function;
}

type Props = StateProps;

const menuItem = ({
  path,
  icon,
  label,
  className,
  // @ts-ignore
  onClick,
}: Props) => (
  <li
    // @ts-ignore
    className={className}
    // @ts-ignore
    onClick={onClick}
  >
    <Link
      // @ts-ignore
      to={path}
    >
      <i className="">{icon}</i>
      <span className="pr-10px">{label}</span>
    </Link>
  </li>
);

export default menuItem;
